export default __webpack_public_path__ + "static/media/emvigo.5ee3acc4.svg";